/**
 * @module app.portal.dashboardCtrl
 *
 * The var names witch contain "loading" mean : is a request pending ?
 */
define(['angular'], function(angular) {


    function DashboardCtrl($scope, $window, $location, $log, $rootScope, authService) {
        let self = {};
        authService.updateLoginStatus(); // on verifie que le token est toujours là

        self.online = navigator.onLine;

        /**
         * Is the app in online mode ?
         * @return {Boolean}
         */
        self.isOnline = function isOnline() {
            return self.online;
        };

        $scope.$on('online', function() {
            self.online = true;
        });

        $scope.$on('offline', function() {
            self.online = false;
        });

        return self;
    }

    DashboardCtrl.$inject = ['$scope', '$window', '$location', '$log', '$rootScope', 'authService'];

    angular.module('app.portal.dashboardCtrl', ['ui-notification']).controller('DashboardCtrl', DashboardCtrl);
});
